import { useQuery } from 'react-query';
import { getBalanceFlowById } from '../sp-firebase/balanceFlowFB';

export const useBalanceFlow = (balanceFlowId: string | undefined) => {
  const enable = balanceFlowId !== undefined;
  const fetchFunction = () => getBalanceFlowById(balanceFlowId || '');
  return useQuery('balance-flow', fetchFunction, { enabled: enable });
};
